import React, { useEffect, useState, Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { ObtenerClasificaRespuesta,ObtenerEstadoAccion,ObtenerMotivo} from '../../../store/actions/encargado-cia-action'

const RecepcionarRespuestaCIA= ({formik, setDisabledMontoNeto, siguienteEstado, setSiguienteEstado}) => {
const [misMotivos, setMisMotivos]=useState([])
const [isMotivo, setIsMotivo]=useState(true)
const [respuesta, setRespuesta]=useState(null)
const [isSelection, setIsSelection]=useState("Seleccione una respuesta...")
const [estado, setEstado]=useState([])
const [accion, setAccion]=useState("")
const [fechaSiniestro, setFecha]=useState("")
const [motivoRespuesta, setMotivoRespuesta]=useState("")

const data_encargado_cia = useSelector((state) => state.encargado_compania) 
const {cfg_form9, antecedentesCasos, clasificaRespuesta, motivo, estadoAccion } = data_encargado_cia
const [datosSiniestro, setDatosSiniestro] = useState({})
const dispatch = useDispatch()

useEffect(() => {
  setEstado(estadoAccion && estadoAccion.estadoAccion) 
  if (estadoAccion && estadoAccion.estadoAccion && estadoAccion.estadoAccion.accionRpta == 229002) {
    setDisabledMontoNeto(false);
  } else {
    setDisabledMontoNeto(true);
  }
}, [estadoAccion]);

useEffect(() => {
  setFecha(antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['FechaSiniestroFormat'])
}, [antecedentesCasos]);

useEffect(() => {   
  let query = Buffer.from(JSON.stringify({"concepto":" 227"})).toString('base64');
  dispatch(ObtenerClasificaRespuesta(query));   

}, [dispatch]);

useEffect(() => {   
  let query = Buffer.from(JSON.stringify({"concepto":" 228"})).toString('base64');
  dispatch(ObtenerMotivo(query));   

}, [dispatch]);
    
 
const convertirFecha=(fecha)=>{
 
  const [dia, mes, ano]=fecha?.split("-")   
  const fechaFormat=[ano, mes,dia].join("-")
  
  return fechaFormat
}
const hoy=()=>{
  const fecha=new Date()
  const hoy=fecha.toISOString().split("T")[0] 
  return hoy
}

  return (
    <>
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: "#4F517A", color: '#FFFFFF' }}
        >
          {cfg_form9 ? cfg_form9.cfg_form9['respuestarecobro-title-recresptacia'] : ""}
        </Card.Header>
        <Container>
          {cfg_form9 ? (
            <div>
              <Row>
                <Col md="4">
                  <Form.Label
                    className='mb-0 mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-clasrspta']+" *"}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{   
                                      
                        formik.handleChange(e)
                        setMisMotivos(motivo && (motivo.motivo).filter(m=>m.agrupacion===parseInt(e.target.value)))                    
                        setIsMotivo(false)
                        setIsSelection("Seleccione el Motivo...")
                        setRespuesta(e.target.value)
                        setDisabledMontoNeto(true);
                        }}
                    name='respuesta'
                    error={formik.errors.respuesta} 
                    
                  ><option value="1">Seleccionar...</option>
                    {clasificaRespuesta && clasificaRespuesta.clasificaRespuesta
                    .filter(p => p.agrupacion === 235001)
                    .map(d=>(
                      <option key={d.id} value={d.id}>{d.nombre}</option>
                    ))}
                  </Form.Select>
                  {formik.errors.respuesta && formik.touched.respuesta ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.respuesta}</Form.Text>) :""}
                </Col >
                <Col md="4">
                  <Form.Label
                    className='mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-cmb-motivo']+" *"}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    disabled={isMotivo}
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setMotivoRespuesta(e.target.value)
                        let query = Buffer.from(JSON.stringify({"clasificacion":respuesta,"motivo":e.target.value})).toString('base64');
                        if (e.target.value !== "1") {
                          dispatch(ObtenerEstadoAccion(query));  
                        } else {
                          setDisabledMontoNeto(true);
                        }                        
                        /*if (respuesta == 227004 && e.target.value == 228005) {//(227004) Pendiente Condicionado - (228005) Sólo Daños Traseros
                          setDisabledMontoNeto(false);
                        } else {
                          setDisabledMontoNeto(true);
                        }*/
                    }}
                    name='motivoRespuestaCIA'
                    value={formik.values.motivoRespuestaCIA =motivoRespuesta}
                    error={formik.errors.motivoRespuestaCIA} 
                  >
                    <option value="1">{isSelection}</option>
                      {misMotivos.map(d=>(
                        <option key={d.id} value={d.id}>{d.nombre}</option>
                      ))}
                  </Form.Select>
                  {formik.errors.motivoRespuestaCIA && formik.touched.motivoRespuestaCIA ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.motivoRespuestaCIA}</Form.Text>) :""}
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-fecharspta']+" *"}
                  </Form.Label>
                  <br />
               
                  <Form.Control
                    className='mt-2'
                    aria-label='Default select example'
                    type="date"
                    min={fechaSiniestro && convertirFecha(fechaSiniestro && fechaSiniestro)} 
                    max={hoy()}
                    name='fechaRespuesta'
                    onChange={e=>{                    
                        formik.handleChange(e)
                        //setFechaSiniestro(e.target.value)
                         }}
                   
                    value={formik.values.fechaRespuesta        
                    }
                    error={formik.errors.fechaRespuesta} 
                   
                  ></Form.Control>
               {formik.errors.fechaRespuesta && formik.touched.fechaRespuesta ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.fechaRespuesta}</Form.Text>) :""}
                </Col>

                <Col>
                  <Form.Label
                    className='mb-0  mt-2'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-estado']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                    {estado?estado.glosaEstado:""}
                  </Form.Text>
                </Col>
              </Row>
              <Row className='mb-3'>
                <Col md="8">
                  <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-input-comentanalista']}
                  </Form.Label>
                  <br />
                  <Form.Control as="textarea" rows={3} 
                      onChange={e=>{                    
                        formik.handleChange(e)
                      // setObservaciones(e.target.value)                        
                        }}
                      name='comentarioAnalista'                   
                      value={formik.values.comentarioAnalista         
                     }
                 />
                </Col>
                <Col>
                  <Row className='mb-3'>
                     <Col>
                        <Form.Label className='mt-3 mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                          {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-lbl-sigaccion']}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                          {estado?estado.glosaAccion:""}
                        </Form.Text>                                
                      </Col>
                  </Row>
                  {estado?.estadoCaso > 0 ? (
                  <Row>
                    <Col>
                      <Form.Label style={{fontWeight: 'bold', fontSize: '14px'}}>
                        {cfg_form9 && cfg_form9.cfg_form9['respuestarecobro-check-confirmar-estado']}
                      </Form.Label>
                      <br />
                      <Form.Check
                          disabled={estado?.estadoCaso == 0}
                          className='mb-4'
                          style={{ fontSize: '14px' }}
                          name='chkCE'
                          label={estado?estado.glosaEstadoCaso:""}
                          checked={siguienteEstado}
                          onChange={(e)=>setSiguienteEstado(e.target.checked)} 
                        />
                    </Col>
                  </Row>
                  ) : "" }
                </Col>               
              </Row>            
            </div>
          ) : ""}
        </Container>
      </Card>
    </>
  )
}

export default RecepcionarRespuestaCIA
